import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors, fontFamilies } from '../../constants/theme';

export const WidgetWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 14,
});

export const HelperNote = styled(Box)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontSize: 14,
  lineHeight: 1.5,
  color: colors.textLight,
  textAlign: 'center',
  whiteSpace: 'pre-line',
  [theme.breakpoints.down('sm')]: {
    fontSize: 13,
  },
}));
